import { useState } from "react";
import useInvoices from "../../data/useInvoices";
import useSinglePart from "../../data/useSinglePart";
import LoadingWheel from "../shared/LoadingWheel";
import CreditInvoiceModal from "../invoices/CreditInvoiceModal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import InvoiceModal from "../invoices/InvoiceModal";

export default function PartInvoiceExpandedRow({ part }: { part: any }) {
  const { invoice } = useSinglePart(part.id!);
  const { downloadInvoice } = useInvoices();
  
  const [openModal, setOpenModal] = useState(false);
  const [creditModalOpen, setCreditModalOpen] = useState(false);

  if (invoice.isLoading) {
    return <LoadingWheel />;
  }

  if (!invoice.data?.data) {
    return <div className="p-4 italic text-gray-400">No invoice found for this part.</div>;
  }

  return (
    <div className="p-4 flex ">
      <InvoiceModal
        open={openModal}
        setOpen={setOpenModal}
        invoice={invoice.data?.data ?? null}
      />
      <CreditInvoiceModal
        open={creditModalOpen}
        setOpen={setCreditModalOpen}
        invoice={invoice.data?.data ?? null}
      />
      <ButtonInput
        label="View Invoice"
        isSubmit={false}
        onClick={() => setOpenModal(true)}
        classes={" mr-4"}
      />
      <ButtonInput
        label="Return Part"
        isSubmit={false}
        onClick={() => setCreditModalOpen(true)}
        classes={"bg-red-500 hover:bg-red-600 mr-4"}
      />
      <ButtonInput
        label="Download Invoice"
        isSubmit={false}
        onClick={() => {
          downloadInvoice(invoice.data?.data.id!);
        }}
        classes={"!bg-emerald-500 hover:!bg-emerald-600"}
      />
    </div>
  )
}